import React from "react";
import ChatListItem from "./ChatListItem";

export default function ChatsSidebar({
  chatsActive,
  userData,
  tabs,
  searchValue,
  targetRef,
  editText,
  onShowAddMessage,
  onTabChange,
  onSearchChange,
  onChatSelect,
  onEditClick,
  onEditChange,
  onEditSave,
}) {
  return (
    <div className="messaging__left">
      <div className="messaging__top">
        <div onClick={onShowAddMessage} className="messaging__top-add">
          <span>
            <img src="/assets/icons/edit-messaging.svg" alt="" />
          </span>
          <p>Message Tech</p>
        </div>
        <div className="messaging__tabs">
          <div
            onClick={() => onTabChange(false)}
            className={`messaging__tab ${!tabs ? "messaging__tab_active" : ""}`}
          >
            Active
          </div>
          <div
            onClick={() => onTabChange(true)}
            className={`messaging__tab ${tabs ? "messaging__tab_active" : ""}`}
          >
            Completed
          </div>
        </div>

        <div className="messaging__search">
          <span>
            <img src="/assets/icons/search-m.svg" alt="search" />
          </span>
          <input
            placeholder="Search"
            type="text"
            value={searchValue}
            onChange={(event) => onSearchChange(event.target.value)}
          />
        </div>
      </div>
      <div ref={targetRef} className="messaging__chats">
        {chatsActive?.map((item) => (
          <ChatListItem
            key={item?.id}
            item={item}
            userData={userData}
            isCompletedTab={tabs}
            editText={editText}
            onSelect={(event) => onChatSelect(event, item)}
            onEditClick={onEditClick}
            onEditChange={onEditChange}
            onEditSave={onEditSave}
          />
        ))}
        {!tabs && (
          <p className="messaging__textBottom">
            Technician messaging is available 24 hours after job completion.
            Contact Techsbook support if you require any further assistance.
          </p>
        )}
      </div>
    </div>
  );
}
